import { TabidooTablePage } from '@/components/vyroba/TabidooTablePage';

/** Databáze nápletů — zrcadlo Tabidoo tabulky „databazenapletu". */
export function DatabazeNapletuPage() {
  return (
    <TabidooTablePage
      table="napletu"
      storagePrefix="napletu"
      title="Databáze nápletů"
      subtitle="Zrcadlo z Tabidoo. Hledej globálně, filtruj po sloupcích, přehazuj a měň šířku sloupců. Klikni na řádek pro detail a editaci."
    />
  );
}
